import { render, staticRenderFns } from "./ConfirmAddressSave.vue?vue&type=template&id=7e8bb2fe&scoped=true"
import script from "./ConfirmAddressSave.vue?vue&type=script&lang=js"
export * from "./ConfirmAddressSave.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAddressSave.vue?vue&type=style&index=0&id=7e8bb2fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8bb2fe",
  null
  
)

export default component.exports